import React from 'react';
import { Table } from 'UI';
import SectionBasePage from 'components/SectionBasePage';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';
import { useSelector } from 'hooks/store';
import { userPermissionsSelector } from 'state/slices/session';

import {
  MainContainer,
  ActionButton,
} from './style';

const OrganizationInventoryRootPage = (): JSX.Element => {
  const userPermissions = useSelector(userPermissionsSelector) || [];
  const availableOrganizations = userPermissions.map((perm) => perm.organization);
  const breadcrumbNavigator = useBreadcrumbNavigation();
  const { url } = useRouteMatch();

  const organizationList = availableOrganizations
    .map((org) => {
      const orgId = org.id;
      return {
        key: orgId,
        title: org.name,
        route: `/${orgId}`,
      };
    });

  return (
    <SectionBasePage>
      <MainContainer>
        <Table
          dataSource={organizationList}
          pagination={false}
        >
          <Table.Column
            title="Estoque"
            key="categories"
            dataIndex="title"
          />
          <Table.Column
            title=""
            dataIndex="route"
            width="150px"
            render={(route, record: { title: string }) => (
              <ActionButton onClick={() => breadcrumbNavigator.push({
                label: `${record.title}`,
                url: `${url}${route}`,
              })}
              >
                visualizar »
              </ActionButton>
            )}
          />
        </Table>
      </MainContainer>
    </SectionBasePage>
  );
};

export default OrganizationInventoryRootPage;
